'use strict';

import { clamp, getUrlParam } from '../../../functions';
import { DropDown } from '../../interfaces/DropDown';
import { BaseElement } from '../../interfaces/BaseElement';
import { changeLangToCurrent, getCurrentLang } from '../../components/langSwitcher/langSwitcher';
import { Scheduler } from '../../components/Scheduler/Scheduler';
import Hammer from 'hammerjs';
import {isMobile, isNoMenu, settingsData} from '../../../settings';
import { createNavigateButton, getContactsDataFromAPI } from './contactUs';
import { McIdDreamsForm, McIdLeadForm } from '../../components/form/McIdLeadForm';
import {contactToAgentWithWidget} from "../../components/chats/chats";
import { BmbyMode } from '../../mode/BmbyMode';

export class McID {
	static fromDreamsMap = McID.utm();
	static active = true;
	static scope = [];

	constructor (data,id) {
		if(!Boolean(config['crmProjectSettings'].general.menuItems.contactUs) && !McID.fromDreamsMap)
			return;

		this.data = data;
		this.id = id;
		this.create();
		McID.scope.push(this);
	}

	create() {
		this.container = new BaseElement()
			.addClass('mc-id-contacts')
			.DOMElement;
		// if (isMobile)
		// 	this.container.addEventListener('click', () => {
		// 		searchSwipedDownHandler(true);
		// 	});

		this.dropdown = settingsData.isConferenceHost
			? new DropDown(this.container,'mc-id', {
					title: 'contactAgent'
				})
				.setCustomHandler(() => { contactToAgentWithWidget(undefined) })
				.create()
			: new DropDown(this.container,'mc-id', {
					title: 'contactAgent'
				})
				.setOpenPosition('top')
				.needsArrowRotate(true)
				.create();

		// this.bottomContainer = new BaseElement()
		// 	.addClass('mc-id__bottom-container')
		// 	.appendTo(this.dropdown.content.DOMElement);

		isMobile && this.#addSwipe(this.dropdown.curtain,this.dropdown);

		let agentLogo =  settingsData.isConferenceHost ? '../img/online.png' : config.contactWidget?.agentImageUrl || '../img/default-manager-logo.png';

		if (McID.fromDreamsMap) {
			agentLogo = '../img/default-manager-logo.png';
		}

		document.documentElement.style.setProperty('--image-agent-url', `url(\'${agentLogo}\')`);

		const logoWrapper = new BaseElement()
			.addClass('mc-id__logo-wrapper')
			.DOMElement;

		new BaseElement()
			.addClass('mc-id__logo', !isMobile ? 'hidden' : null)
			.appendTo(logoWrapper)
			.DOMElement;

		this.dropdown.dropDown.insertAdjacentElement('afterbegin',logoWrapper);

		this.consoltoStatus = new BaseElement()
			.addClass('mc-id__consolto-status','hidden')
			.DOMElement;

		this.dropdown.dropDown.insertAdjacentElement('afterbegin',this.consoltoStatus);

		Object.entries(this.data).forEach(([key,data]) => {
			let element;

			switch (key) {
				case 'mcId':
					element = new McIDScheduler(data);
					break;
				case 'whatsApp':
					element = new McIDWhatsApp(data);
					break;
				case 'callNow':
					element = new McIDCallNow(data);
					break;
				case 'leadForm':
					element = new McIDLead(data);
					break;
			}

			this.dropdown.add(element?.getDOM());
		});
	}

	#addSwipe(element,scope) {
		let dragStarted = false;
		let panDirection = null;
		let state;

		const swipe = new Hammer.Manager(element);
		swipe.add(new Hammer.Pan({
			threshold: 10
		}));

		const panHandler = (direction) => {
			switch (direction) {
				case 'panup':
					element.parentElement.style.bottom = '';
					break;
				case 'pandown':
					scope.hide();
					break;
			}
			dragStarted = false;
			panDirection = null;
			setTimeout(() => {
				if (!dragStarted) {
					element.parentElement.style.bottom = '';
				}
			},400);
		};

		swipe.on('panstart',() => {
			state = element.parentElement.getBoundingClientRect();
		});


		swipe.on('panup pandown', (e) => {
			const position = clamp(e.deltaY * -1,state.height * -1,0);
			element.parentElement.style.bottom = `${position}px`;
			panDirection = e.additionalEvent;
			dragStarted = true;
			if (e.isFinal) {
				panHandler(panDirection);
			}
		});

		swipe.on('panend', () => {
			if (dragStarted && panDirection) {
				panHandler(panDirection);
			}
		});
	}

	updateConsoltoStatus(status) {
		this.consoltoStatus.className = `mc-id__consolto-status ${status}`;
	}

	addNewButton(element) {
		this.dropdown.add(element);
	}

	addNewElement(element) {
		element.classList.add('dropdown--not-btn');
		this.dropdown.add(element);
	}

	static addNewButton(element,id) {
		const scope = McID.scope.find(scope => scope.id === id);
		if (scope) {
			scope.addNewButton(element);
		}
	}

	static addNewElement(element,id) {
		const scope = McID.scope.find(scope => scope.id === id);
		if (scope) {
			scope.addNewElement(element);
		}
	}

	static updateConsoltoStatus(status) {
		McID.scope.forEach(scope => scope.updateConsoltoStatus(status));
	}

	static getData() {
		return JSON.parse(getUrlParam('mcId'));
	}

	static utm() {
		return getUrlParam('utm_source') === 'dreamsmap';
	}

	static prepareMenuItems(menuItems) {
		if (McID.fromDreamsMap && !isMobile) {
			menuItems.contactUs = false;
		} else if (McID.fromDreamsMap && isMobile) {
			menuItems.contactUs = true;
		}
	}

	static resizeHandler() {
		if(isMobile || BmbyMode.active) return;
		const asideTop = document.querySelector('.aside__top__container').getBoundingClientRect();
		const asideBottom = document.querySelector('.aside__bottom__container').getBoundingClientRect();
		const logo = document.querySelector('.mc-id__logo');
		const logoHeight = 80;

		if (asideBottom.top - logoHeight <= asideTop.bottom) {
			logo?.classList.add('hidden');
		} else {
			logo?.classList.remove('hidden');
		}
	}
}


export class McIDElement {
	static handlers = {};

	constructor (element = 'div') {
		this.element = new BaseElement(element)
			.addClass('mc-id__element','language-string')
			.event('click',this.handler.bind(this));
	}

	addClass(...args) {
		this.element.addClass(...args);
		return this;
	}

	removeClass(...args) {
		this.element.removeClass(...args);
		return this;
	}

	addTranslate(key) {
		this.element
			.addAttribute('data-dictionary',key)
			.innerHtml(changeLangToCurrent(key));

		return this;
	}

	addTranslateObject(object) {
		Object.entries(object).forEach(([lang,text]) => {
			this.element.addAttribute(`data-lang-${lang}`,text);
		});

		this.element.innerHtml(object[getCurrentLang()]);

		return this;
	}

	addAttribute(key,value) {
		this.element.addAttribute(key,value);

		return this;
	}

	handler() {}

	getDOM() {
		return this.element.DOMElement;
	}
}


class McIDWhatsApp extends McIDElement{
	constructor (data) {
		super();

		this.data = data;
		this.addTranslate('whatsApp');
		const dataRole = 'whatsApp';
		this.addAttribute('data-role', dataRole);
		this.addClass(this.data.icon || 'icon-whatsapp');

		if (!McIDElement.handlers?.[dataRole])
			McIDElement.handlers[dataRole] = this.handler.bind(this);
	}

	handler () {
		const href = 'https://wa.me/' + this.data.tel;
		window.open(href,'_blank');
	}
}

class McIDScheduler extends McIDElement {
	constructor (data) {
		super();

		this.data = data;
		this.addTranslate('mcId');
		const dataRole = 'scheduler';
		this.addAttribute('data-role',dataRole);
		this.addClass(this.data.icon || 'icon-video-call');
		this.scheduler = new Scheduler(this.data.guid);

		if (!McIDElement.handlers?.[dataRole])
			McIDElement.handlers[dataRole] = this.handler.bind(this);
	}

	handler () {
		this.scheduler.meeting.show();
	}
}


class McIDCallNow extends McIDElement {
	constructor (data) {
		super();

		this.data = data;
		this.addTranslate('callNow');
		const dataRole = 'callNow';
		this.addAttribute('data-role',dataRole);
		this.addAttribute('data-tel', this.data.tel);
		this.addClass(this.data.icon || 'icon-call');

		if (!McIDElement.handlers?.[dataRole])
			McIDElement.handlers[dataRole] = this.handler.bind(this);
	}

	handler () {
		const href = 'tel:' + this.data.tel;
		window.open(href,'_blank');
	}

	getClone(data) {
		return new McIDCallNow({
			icon: data.icon,
			tel: data.tel
		});
	}
}

export class McIDLead extends McIDElement {
	constructor (data) {
		super();

		this.data = data;
		this.addTranslate('leadForm');
		const dataRole = 'leadForm';
		this.addAttribute('data-role',dataRole);
		this.addClass(this.data.icon || 'icon-chat');

		if (!McIDElement.handlers?.[dataRole])
			McIDElement.handlers[dataRole] = this.handler.bind(this);
	}

	handler () {
		if (McID.fromDreamsMap) {
			new McIdLeadForm();
		} else {
			new McIdDreamsForm();
		}
	}
}


export class McIDEmail extends McIDElement {
	constructor (data) {
		super('a');

		this.data = data;
		this.addTranslate(isMobile ? this.data.url : 'Email');
		const dataRole = 'email';
		this.addAttribute('data-role',dataRole);
		this.addAttribute('href','mailto:' + this.data.url);
		this.addClass(this.data.icon || 'icon-email');

		// McIDElement.handlers.push({[dataRole]: this.handler});
	}

	handler (e) {
		e.preventDefault();
		const href = 'mailto:' + this.data.url;
		window.open(href,'_blank');
	}
}


export class McIDWebsite extends McIDElement {
	constructor (data) {
		super('a');

		this.data = data;
		this.addTranslate(this.data.url);
		const dataRole = 'web';
		this.addAttribute('data-role',dataRole);
		this.addAttribute('href',this.data.url);
		this.addClass(this.data.icon || 'icon-site');

		// McIDElement.handlers.push({[dataRole]: this.handler});
	}

	handler (e) {
		e.preventDefault();
		const href = this.data.url;
		window.open(href,'_blank');
	}
}

export class McIDContactUs {
	constructor () {
		if(!Boolean(config['crmProjectSettings'].general.menuItems.contactUs))
			return;

		this.element = new BaseElement()
			.addClass('mc-id__contacts-block');

		this.create();
	}

	async create() {
		const data = await getContactsDataFromAPI();
		const mcidContentElement = document.querySelector('.mc-id__content');

		isMobile && new BaseElement('h1')
			.addClass('mc-id__contact-us-title', 'language-string')
			.setAttributes({'data-dictionary': 'contactUs'})
			.innerHtml(changeLangToCurrent('contactUs'))
			.appendTo(mcidContentElement);

		data.forEach(item => {
			let element;

			switch (item.title) {
				// case 'phones':
				case 'phone':
					const iconClass = 'icon-call';
					const tel = item.crmData.value || item.crmData
					const callNowArguments = {
						icon: iconClass,
						tel
					};

					const btn = new McIDCallNow(callNowArguments);

					if (isMobile) {
						if (!mcidContentElement.querySelector(`.mc-id__content > .${iconClass}`))
							McID.addNewButton(btn.getDOM(),'mc-menu');

						element = btn.getClone(callNowArguments)
							.addClass('mc-id__element-block__child',`contacts-block__child--${item.title}`)
							.addTranslate(tel)
							.getDOM();
					} else if (!mcidContentElement.querySelector(`.mc-id__content > .${iconClass}`)) {
						McID.addNewButton(btn.getDOM(),'mc-menu');
					}
					break;
				case 'title':
				case 'text':
					element = new McIDElement()
						.addClass('mc-id__element-block__child',`contacts-block__child--${item.title}`)
						.addTranslateObject(item.crmData)
						.getDOM();
					break;
				// case 'emails':
				case 'email':
					if (mcidContentElement.querySelector(`.${item.icon}`))
						break;

					element = new McIDEmail({
						url: typeof item.crmData === 'object' ? item.crmData.value : item.crmData,
						icon: item.icon
					});

					if (isMobile) {
						element = element.addClass('mc-id__element-block__child',`contacts-block__child--${item.title}`)
							.getDOM();
					} else {
						McID.addNewButton(element.getDOM(),'mc-menu');
					}

					break;
				case 'website':
					element = new McIDWebsite({
						url: item.crmData,
						icon: item.icon
					});

					if (isMobile) {
						element = element
							.addClass('mc-id__element-block__child',`contacts-block__child--${item.title}`)
							.getDOM();
					}
					else {
						element = element.getDOM();
					// 	McID.addNewButton(element.getDOM(),'mc-menu');
					}

					break;
				case 'whatsApp':
					const whatsAppArgs = {
						tel: item.tel,
						icon: item.icon
					};

					const whatsAppElement = new McIDWhatsApp(whatsAppArgs);
					McID.addNewButton(whatsAppElement.getDOM(),'mc-menu');

					break;
			}

			if (element) {
				this.element.appendElement(element);
			}
		});

		if (this.element.DOMElement.children.length && isMobile) {
			const navigate = new McIDElement()
				.addClass('mc-id__element-block__child',`contacts-block__child--navigate`)
				.removeClass('language-string')
				.getDOM();
			createNavigateButton(navigate);
			this.element.appendElement(navigate);

			McID.addNewElement(this.element.DOMElement,'mc-menu');
		}

		if (isMobile) {
			const headerWrapper = new BaseElement()
				.addClass('mc-id__element-block__child', 'contacts-block__header-wrapper')
				.appendTo(this.element.DOMElement);
			const textWrapper = new BaseElement()
				.addClass('contacts-block__text-wrapper')
				.appendTo(headerWrapper.DOMElement);
			const title = new BaseElement(this.element.DOMElement.querySelector('.contacts-block__child--title'));
			const text = new BaseElement(this.element.DOMElement.querySelector('.contacts-block__child--text'));
			const navigate = new BaseElement(this.element.DOMElement.querySelector('.contacts-block__child--navigate'));
			title.appendTo(textWrapper.DOMElement);
			text.appendTo(textWrapper.DOMElement);
			navigate.appendTo(headerWrapper.DOMElement);
		}
	}
}
